import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectText } from "../../../translation/translationSlice";
import "./Tabs.scss";

const Tabs = React.memo((props) => {
  const dispatch = useDispatch();
  const t = useSelector(selectText);
  return (
    <div className="Tabs">
      {props.options?.map((item, index) => {
        const value = typeof item === "object" ? item.value : item;
        const label = typeof item === "object" ? item.label : item;

        return (
          <div
            key={index}
            className={`Tab${props.value === value ? " selected" : ""}`}
            onClick={(e) =>
              props.action &&
              dispatch({
                ...props.action,
                payload: {
                  ...props.action.payload,
                  value,
                },
              })
            }
          >
            <div className="label">{t(label)}</div>
            <div className="indicator" />
          </div>
        );
      })}
    </div>
  );
});

export default Tabs;
